import { gsap } from 'gsap'
import EnvUtil from '../util/EnvUtil'
import SlideItem from './SlideItem'

class Slide
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Slide
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //アイテム格納配列
    this.items = []

    //ロックフラグ
    this.isLock = false

    //インデックス
    this.index = -1

    //オートプレイ用のタイマー
    this.autoPlayTImer = null

    //スライドアイテム生成
    $('.slide-item').each((index) => {
      const slideItem = new SlideItem($('.slide-item').eq(index))
      this.items.push(slideItem)
    })

    //ページング追加
    for(let i=0; i<this.items.length; i++)
    {
      $('.fv__slide-paging').append('<li class="fv__slide-paging-item"><a href=""></a></li>')
    }

    //ページングのボタンアクション
    const holder = this
    $('.fv__slide-paging-item >a').each(function(index){
      $(this).click((e)=>{
        e.preventDefault()
        holder.change(index)
      })
    })
  }

  start()
  {
    this.change(0)
  }


  next()
  {
    if(this.isLock) return

    let nextIndex = this.index + 1
    if(nextIndex >= this.items.length) nextIndex = 0

    this.change(nextIndex)
  }

  change(nextIndex)
  {
    if(this.index == nextIndex) return
    if(this.isLock) return

    //オートプレイをリセット
    if(this.autoPlayTImer) this.autoPlayTImer.kill()

    //ページングをアップデート
    $('.fv__slide-paging-item >a').each(function(index){
      if(nextIndex == index)
      {
        $(this).addClass('current')
      }
      else
      {
        $(this).removeClass('current')
      }
    })


    //1秒間ロック
    this.isLock = true
    gsap.delayedCall(3.0, ()=>{
      this.isLock = false
    })

    //前のスライドを消す
    if(this.index != -1)
    {
      const prevItem = this.items[this.index]
      prevItem.leave()
    }

    //インデックス更新
    this.index = nextIndex

    //次のスライド表示
    const nextItem = this.items[this.index]
    nextItem.show()

    //自動再生
    this.autoPlayTImer = gsap.delayedCall(10, ()=>{
      this.next()
    })
  }


  
	// ---------------------------------------------------------------------------------------------------------
}

export default Slide